<template>
  <div>
    <h4 v-text="rliss"></h4>
    <SSRSousRegion v-for='(value, name) in data' :name='name' :data='value'
      :key='name' :secteur="secteur"/>
  </div>
</template>

<script>
import SSRSousRegion from '@/components/ssr/SsrSousRegion.vue'

export default {
  name: 'SsrRliss',
  components: {
    SSRSousRegion,
  },
  props: {
    rliss: String,
    secteur: String,
    data: Object
  },
  computed: {
    test1() {
      return Object.entries(this.data);
    },
    // rliss() {
    //   var rliss = Array();
    //   var rl = Object.keys(this.data);
    //   console.log(rl)
    //   for(var i of rl) {
    //     console.log(i);
    //     var rliss_obj = this.data[i];
    //     rliss_obj['name'] = i;
    //     rliss.push(rliss_obj);
    //   }
    //   return rliss;
    // }
  }

}
</script>
